import React, { useState, useEffect, Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'
import '../../assets/css/project-creation-mytask.css';
import { getMyTaskAction, getInProgressAction, updateStatusAction } from '../../redux/actions/MyTaskAction';
import { TaskTable, InprogressTable } from '../../components/AuditCommittee';

import { Storage, AppSettings } from '../../configs'

import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import ChangeCommitteeTable from './Table/ChangeCommitteeTable';
import { ChangeCommitteeService } from '../../services';
import { useHistory } from "react-router";
import { msg } from '../../components/Notifications/MsgBox';
import UserServices from '../../services/UserServices';

export default () => {

    const [resultSearch, setResultSearch] = useState([]);
    const history = useHistory();
    const [openLoading, setOpenLoading] = React.useState(false);
    const emp = Storage.getEmployeePIS();
    const [appReadonly,setAppReadonly] = useState(true);

    const handleApplicationCheckReadonly = async () =>
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                setAppReadonly(false)
            }
        })
    }

    useEffect(() => {
        setsearchData('');
        handleApplicationCheckReadonly()

    }, [])

    function setsearchData(serachConditionModel) {

        try {
            setOpenLoading(true)
            ChangeCommitteeService.getChangeCommitteeAll(serachConditionModel, emp.employeeId).then((response) => {
                console.log("searchReportAction");
                console.log(response);
                setResultSearch(response)
                // if (response.success) {
                //     setResultSearch(response.data)
                // } else {
                //     setResultSearch([])
                //     msg.error(response.message)
                // }
                setOpenLoading(false)
            })
        } catch (e) {
            console.log(e);
            msg.error("System error.")
            setOpenLoading(false)
        }
    }

    const handleAdd = (event) => {
        try {

            ChangeCommitteeService.setChangeCommittee({}).then((response) => {

                console.log("setChangeCommittee");
                console.log(response);
                if(response.isSuccess == true){
                    if(response.resData != null){
                        history.push(`/ChangeCommittee/${response.resData.running}`);
                    }
                }
                
                
            })
        } catch (e) {
            console.log(e);
            msg.error("System error.")
        }
        
    };

    function IsShowsLoading(props) {
        const { isLoading } = props;
        return (
            (isLoading ?
                <div id="loading-element">
                    <div id="loading-indicator">
                        <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                </div>
                : null)
        )
    }

    
    return (
        <div className="tor tor-template-list">
            <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
            <SecureGateRoute />
            <div id="main-content">
                <div className="page-body">
                    <BreadCrumb breadcrumb={[
                        { name: 'RRS Home', url: AppSettings.defaultUrl },
                        { name: 'เปลี่ยนแปลงคณะกรรมการตรวจรับ', url: '' }
                    ]}></BreadCrumb>

                    <div className="sp-page-header-panel row">
                        <div className="col-md-5 sp-page-header">
                            <h1 className="sp-page-header1">เปลี่ยนแปลงคณะกรรมการตรวจรับ</h1>
                        </div>
                    </div>

                    <div className="sp-page-result-container">

                        <br></br>
                        <div className="rrs-detail2">
                            {appReadonly === false && <div className="col-md-4" style={{ textAlign: "left", paddingTop: 20 }}>
                                <a onClick={handleAdd} className="sp-bt-addmore" style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10 }}>
                                    <i className="icon btn-plus" />
                                    <span>เพิ่ม</span>
                                </a>
                            </div>}
                        </div>
                        <br></br>
                        <div className="rrs-detail2">
                            <div className="sp-table-container">
                                <div className="row no-gutters sp-table-content">
                                    <ChangeCommitteeTable
                                        dataTable_Committee={resultSearch}
                                        length={0}
                                    ></ChangeCommitteeTable>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* <DetailBotLogModal /> */}
                </div>
            </div>


        </div >
    )


}




